import { useCookies } from 'react-cookie'

export const useAuth = () => {
  const [cookies] = useCookies(['authenticated', 'registration_authorized'])

  // check that cookie token exists and is not empty
  const isAuthenticated = !!cookies.authenticated || false

  // check that cookie registration_authorized exists and is not empty
  const isRegistrationAuthorized = !!cookies.registration_authorized || false

  return {
    isAuthenticated,
    isRegistrationAuthorized,
  }
}
